import { BlockActionType } from '../enums';
import { MixedObject } from '@core/interfaces/mixed-object';

export interface BlockActionModel {
  id: number;
  className: string;
  ariaLabel: string;
}

export class BlockAction {

  static None: BlockAction = new BlockAction(BlockActionType.NONE);
  actionType: BlockActionType;
  actionName: string;
  actionData: MixedObject;
  actionRequestForModelId: number;
  actionRequestForModel: BlockActionModel;
  linkDescription: string;
  parentType?: string;

  constructor(actionType: BlockActionType) {
    this.actionType = actionType;
  }
}
